import React, { useState, useEffect, useContext } from 'react'
import { AppLoader } from '@portal/kit/pkg/components'
import { useParams } from 'react-router-dom'

import { PaymentContext } from 'components/providers/payment'
import PaymentFailed from './payment-failed'
import PaymentSucces from './payment-success/payment-succes'
import OffersBreadcrumb from '../breadcrumb'
import paymentServices, { offerPaths, redirectToPayment } from 'helpers/payment-services'

function OfferConfirmation() {
  const { offerId, order_id, source } = useParams()
  const [globalError, setGlobalError] = useState(null)
  const { isStripe, boughtProducts, selectedOffer, paymentError, order, getOffer, loadOrder } = useContext(PaymentContext)

  useEffect(() => {
    getOffer(offerId)
  }, [offerId, getOffer])

  useEffect(() => {
    loadOrder(order_id)
  }, [order_id, loadOrder])

  const retryPayment = async () => {
    try {
      const { retryOrder } = paymentServices(isStripe)
      const paths = offerPaths(offerId)
      const response = isStripe
        ? await retryOrder(null, order_id, paths.confirmationInProgress, { cancel_path: paths.checkout })
        : await retryOrder(null, order_id, paths.confirmation)

      redirectToPayment(isStripe, response.data)
    }
    catch (e) {
      handleOrderErrors(e)
    }
  }

  const handleOrderErrors = (e) => {
    if (e.response && e.response.data && e.response.data.error) {
      setGlobalError(e.response.data.error.message)
    }
    else {
      setGlobalError('form.error')
    }
  }

  if (!order && !paymentError) return <AppLoader />

  if (paymentError || globalError)
    return (
      <PaymentFailed
        error={paymentError || globalError}
        order={order}
        offer={selectedOffer}
        retry={retryPayment}
      />
    )

  if (selectedOffer && boughtProducts)
    return (
      <PaymentSucces
        offer={selectedOffer}
        products={boughtProducts}
        source={source}
      />
    )

  return null
}

export default function OfferConfirmationWithBreadcrumb() {
  return (
    <>
      <OffersBreadcrumb step="confirmation" />
      <OfferConfirmation />
    </>
  )
}
